/* eslint no-use-before-define: 0 */ // --> OFF
<template>
  <div class="calendar-container">
    <vue-scheduler-v
      @event-clicked="eventClicked"
      @event-created="eventCreated"
      :event-dialog-config="dialogConfig"
      event-display="name"
      initial-view="month"
      :initial-date="activeDate"
      :events="events"
      :available-views="['month', 'day']"
      :estTime="estTime"
    ></vue-scheduler-v>
  </div>
</template>

<script>
import apiClientCreator from "../../../../helpers/api/request";
import VueSchedulerV from "./v-calendar-scheduler/components/VueScheduler";
import "./v-calendar-scheduler/scss/_variables.scss";
import "./v-calendar-scheduler/scss/main.scss";
import { EventBus } from "./v-calendar-scheduler/components/EventBus";
import { setTasks } from "../../../../store/tasks.store/mutations";
export default {
  components: {
    VueSchedulerV
  },
  props: {
    taskType: {
      type: Object
    },
    mode: {
      type: String
    },
    estTime: {
      type: String
    },
    taskDateTime: {
      type: Object
    },
    activeDate: {
      default() {
        return {};
      }
    }
  },
  mounted() {
    if (this.mode == "add") {
      this.getMyTasks();
    }
    this.$root.$on("active_date_changed", data => {
      this.activeDate = null;
    });
  },
  data() {
    return {
      tasksFromDb: null,
      choosedDate: null,
      // startDisplayDate: new Date(),
      startDisplayDate: this.activeDate,
      events: [],
      dialogConfig: {
        title: "Choose A Time",
        createButtonLabel: "Save",
        enableTimeInputs: true,
        fields: [
          {
            name: "select-time-range",
            type: "select",
            required: true,
            label: "Time period"
            // value: 'email@example.com'
          }
        ]
      }
    };
  },

  watch: {
    events: function() {
      if (this.events.length - this.tasksFromDb == 1) {
        if (this.events[this.events.length - 1].task_id !== undefined) {
          // this.events[this.events.length - 1].name = this.taskType.title;
          // let x = this.events.map(event => event.task_id === this.events[this.events.length - 1].task_id).indexOf(this.events[this.events.length - 1].task_id)
          let oldTaskId = this.events
            .map(function(event) {
              return event.task_id;
            })
            .indexOf(this.events[this.events.length - 1].task_id);
          delete this.events[oldTaskId];
        } else {
          if (this.taskType) {
            this.events[this.events.length - 1].name = this.taskType.title;
          }
        }
      } else if (this.events.length - this.tasksFromDb > 1) {
        if (this.taskType) {
          this.events[this.events.length - 1].name = this.taskType.title;
          delete this.events[this.events.length - 2];
        }
      }
    }
  },
  methods: {
    async getMyTasks() {
      let path = apiClientCreator(`tasks/my`);
      let tasks = await path.get("");
      this.tasksFromDb = tasks.data.length;

      // if (this.taskDateTime !== null){
      //   tasks.data.push(this.taskDateTime)
      // }
      this.showTaskOnCalendar(tasks);
    },

    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },

    showTaskOnCalendar(tasks) {
      let eventsList = [];
      tasks.data.forEach(task => {
        let details = {
          date: task.start_time,
          startTime: this.formatStartDateForCalendar(task.start_time),
          endTime: this.formatEndDateForCalendar(task.end_time),
          name: this.setTaskInfoOnCalendar(task),
          eventClass: this.setEventClass(task.type_id),
          task_id: task.id,
          task_status: this.setEventClassByStatus(task.status_id)
          // user: this.getUsersAssignment(task.task_assignment)
        };

        eventsList.push(details);
      });
      this.events = eventsList;
    },

    setTaskInfoOnCalendar(task) {
      if (task.content !== undefined && task.content !== null) {
        return `${this.removeHtml(task.content)}`;
      }
    },

    formatStartDateForCalendar(time) {
      if (time != null || time != undefined) {
        let startTime = time.slice(11, 16);
        return startTime;
      } else {
        return time;
      }
    },

    formatEndDateForCalendar(time) {
      if (time != null || time != undefined) {
        let endTime = time.slice(11, 16);
        return endTime;
      } else {
        return time;
      }
    },

    setEventClass(type_id) {
      if (type_id !== undefined) {
        let eventClass;
        switch (type_id) {
          case 1:
            eventClass = "event-task";
            break;
          case 2:
            eventClass = "event-meeting";
            break;
          case 3:
            eventClass = "event-announcement";
            break;
          case 4:
            eventClass = "event-comp-meeting";
            break;
          case 5:
            eventClass = "event-repeated-task";
            break;
          case 6:
            eventClass = "event-opening-shift";
            break;

          default:
            eventClass = "event-task";
        }
        return eventClass;
      }
    },
    setEventClassByStatus(task_status) {
      if (task_status !== undefined) {
        let eventClassByStatus;
        switch (task_status) {
          case 1:
            eventClassByStatus = "event-completed";
            break;

          default:
            eventClassByStatus = "event-task";
        }
        return eventClassByStatus;
      }
    },
    eventClicked(event) {
      this.$emit("changeModeToEdit", event);
    },

    eventCreated(event) {
      this.choosedDate = event;
      this.$emit("changeDate", this.choosedDate);
    },
    dayClicked(date) {},
    timeClicked(dateWithTime) {},
    getUsersAssignment(task_assignment) {
      let usersAssignment = [];
      task_assignment.forEach(item => {
        usersAssignment.push(item.assigned_to);
      });
      return usersAssignment;
    }
  }
};
</script>

<style scoped lang="sass">
@import "./v-calendar-scheduler/lib/main.css"
</style>
